import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { clsx } from 'clsx';
import { getUnits } from '../../utils';
import { Star } from '../Star';
import { getValue } from './utils/getValue';
import { getCount } from './utils/getCount';
import * as styles from './Stars.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Stars = function Stars(_ref) {
  var value = _ref.value,
    count = _ref.count,
    uniqueKey = _ref.uniqueKey,
    theme = _ref.theme,
    percentage = _ref.percentage,
    containerClassName = _ref.containerClassName,
    unitClassName = _ref.unitClassName,
    onClick = _ref.onClick;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeIndex = _React$useState2[0],
    setActiveIndex = _React$useState2[1];
  var onMouseLeave = React.useCallback(function () {
    setActiveIndex(undefined);
  }, []);
  var onUnitMouseOver = React.useCallback(function (unitIndex) {
    if (!onClick) {
      return;
    }
    setActiveIndex(unitIndex);
  }, [onClick]);
  var units = getUnits(getCount(count), getValue({
    value: value,
    percentage: percentage,
    activeIndex: activeIndex
  }), percentage);
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles['container'], containerClassName),
    onMouseLeave: onMouseLeave,
    children: units.map(function (value, index) {
      return /*#__PURE__*/_jsx(Star, {
        className: unitClassName,
        index: index,
        onClick: onClick,
        onMouseOver: onUnitMouseOver,
        theme: theme,
        uniqueKey: uniqueKey,
        value: value
      }, "".concat(uniqueKey, "-").concat(index));
    })
  });
};